// extracted by mini-css-extract-plugin
export default {"root":"LoginDialog_root__uDyuv","title":"LoginDialog_title__M84oz","text":"LoginDialog_text__rG8YR","btn":"LoginDialog_btn__ziS2w"};